<template>
  <div id="user-edit-account-details">
    <div class="vx-row">
      <div class="vx-col w-full">
        <h3>URLs</h3>
      </div>
    </div>

    <div class="vx-row mt-2">
      <div class="vx-col w-full">
        <label class="vs-input--label font-bold">Allowed Callback URLs</label>
        <p>{{ callbacks }}</p>
      </div>
    </div>
    <div class="vx-row mt-2">
      <div class="vx-col w-full">
        <label class="vs-input--label font-bold">Allowed Logout URLs</label>
        <p>{{ allowed_logout_urls }}</p>
      </div>
    </div>
    <div class="vx-row mt-2">
      <div class="vx-col w-full">
        <label class="vs-input--label font-bold">Allowed Web Origins</label>
        <p>{{ web_origins }}</p>
      </div>
    </div>
    <div class="vx-row mt-2">
      <div class="vx-col w-full">
        <label class="vs-input--label font-bold">Allowed Web Origins (CORS)</label>
        <p>{{ allowed_origins }}</p>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.value)),
    }
  },
  computed: {
    callbacks() {
      return this.data_local.ExternalIdentity.callbacks.join(',');
    },
    allowed_logout_urls() {
      return this.data_local.ExternalIdentity.allowed_logout_urls.join(',');
    },
    web_origins() {
      return this.data_local.ExternalIdentity.web_origins.join(',');
    },
    allowed_origins() {
      return this.data_local.ExternalIdentity.allowed_origins.join(',');
    }
  },
}
</script>
